// extracted by mini-css-extract-plugin
export default {"promotionsList":"style_promotionsList__6NMcU","fetchingContainer":"style_fetchingContainer__Kv+Vl"};